import { LitElement, html } from 'lit';
import styles from './styles';
import '../input/Input';
import '../icons/IconChervonDown';

class Dropdown extends LitElement {
  static styles = styles;

  static properties = {
    name: { type: String },
    id: { type: String },
    ariaDescribedBy: { type: String, attribute: 'aria-describedby' },
    ariaLabel: { type: String, attribute: 'aria-label' },
    ariaInvalid: { type: String, attribute: 'aria-invalid' },
    label: { type: String },
    options: { type: Array },
    popoverHidden: {
      type: Boolean,
      state: true,
    },
  };

  constructor() {
    super();
    this.name = '';
    this.id = undefined;
    this.ariaDescribedBy = '';
    this.ariaLabel = '';
    this.ariaInvalid = '';
    this.label = '';
    this.options = [];
    this.popoverHidden = true;
  }

  connectedCallback() {
    super.connectedCallback();

    this.#addEventListeners();
  }

  #addEventListeners() {
    document.addEventListener('click', (event) => {
      const dropDownContainer = this.renderRoot.querySelector('.dropdown-container');
      let contains = false;

      event.composedPath().forEach((item) => {
        if (item instanceof Element && dropDownContainer.contains(item)) {
          contains = true;
        }
      });

      if (!contains) this.#closePopover();
    });
  }

  #closePopover() {
    this.popoverHidden = true;
  }

  #toggleHandler() {
    // If the popover is closed, open it
    if (this.popoverHidden) {
      this.popoverHidden = false;
      return;
    }

    this.#closePopover();
  }

  render() {
    return html`
      <div class="dropdown-container">
        <div class="dropdown-button" @click=${() => this.#toggleHandler()}>
          ${this.label}
          <tenable-icon-chervon-down class="dropdown-icon"></tenable-icon-chervon-down>
        </div>
        ${this.popoverHidden ? html`` : html`
          <div class="dropdown-body">
            <slot></slot>
          </div>
        `}
      </div>
    `;
  }
}

customElements.define('tenable-dropdown', Dropdown);
